import { CSSObject, styled } from 'libs/ui/styled';

export const TitleStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,

  '.title-backLink': {
    marginLeft: -10,
    display: 'flex',
  } as CSSObject,

  [theme.breakpoints.down('mobile')]: {
    '.title-backLink': {
      marginLeft: -10,
    } as CSSObject,

    '.title-backLink-icon': {
      [theme.breakpoints.down('mobile')]: {
        height: 27,
        width: 27,
      },
    },
  },
}));
